export class PrescriptionMedicine {
    public idPrescriptionMedicine: number;
    public idPrescription: number;
    public idMedicine: number;
    public idUsage: number;
    public idAdministrationType: number;
    public administrationType: string;
    public quantity: number;
    public idPresentation: number;
    public presentation: string;
    public idFrequency: number;
    public idTreatmentPeriod: number;
    public observation: string;
    public datetimeInclusion: Date;
    public idDilution: number;
    public dilution: string;
    public idPrescriptionStatus: number;
    public idMeasurementUnit: number;
    public idDoseToAdministered: number;
    public idLookupAdministrationLocation: number;
    public nonDispensationReason: string;
    public nonDispensationIdUser: number;
    //public string medicineReportName: string;
    public justification: string;
    public datetimeNonDispensation: Date;
    public idSubFrequency: number;
    public idDilutionUnit: number;
    public dilutionQuantity: string;
    public idUserRelease: number;
    public datetimeRelease: Date;
    public datetimeSuspended: Date;
    public idMedicalCareSuspended: number;
    public calculatedTotalQuantity: number;
    public motiveSuspended: string;
}